(function() {
    let xCenter = window.innerWidth / 2;
    let yCenter = window.innerHeight / 2;

    const loadEffects = () => {
        const effects = document.querySelectorAll('[data-effect]') as NodeListOf<HTMLElement>;

        for(const effect of effects) {
            const effectName = effect.getAttribute('data-effect');
            switch(effectName) {
                case 'mouse-shake':
                    loadShake(effect, loadMouseShake);
                    break;
                case 'mouse-skew-shake':
                    loadShake(effect, loadMouseSkewShake);
                    break;
                default:
                    break;
            }
        }
    }

    const loadShake = (element: HTMLElement, callback: (element: HTMLElement, xValue: number, yValue: number) => void) => {
        window.addEventListener('mousemove', (event) => {
            const x = event.clientX;
            const y = event.clientY;

            const xDistance = x - xCenter;
            const yDistance = y - yCenter;

            const xPercentage = xDistance / xCenter;
            const yPercentage = yDistance / yCenter;

            callback(element, xPercentage, yPercentage);
        });
    }

    const loadMouseShake = (element: HTMLElement, xValue: number, yValue: number) => {
        const xRange = parseInt(element.getAttribute('data-effect-x-range') || '40');
        const yRange = parseInt(element.getAttribute('data-effect-y-range') || '40');

        element.style.transform = `translate(${xValue * xRange}px, ${yValue * yRange}px)`;
    };

    const loadMouseSkewShake = (element: HTMLElement, xValue: number, yValue: number) => {
        const xRange = parseInt(element.getAttribute('data-effect-x-range') || '4');
        const yRange = parseInt(element.getAttribute('data-effect-y-range') || '4');

        element.style.transform = `skew(${-xValue * xRange}deg, ${-yValue * yRange}deg)`;
    }

    window.addEventListener('load', () => {
        loadEffects();
    });

    window.addEventListener('resize', () => {
        xCenter = window.innerWidth / 2;
        yCenter = window.innerHeight / 2;
    });
})()